export const LIBRARY_PATH = '/library'

const legacyWorkspaceParams = ['share', 'review', 'project', 'folder', 'mobile', 'embedded', 'simulator', 'admin']

export function isMarketingRoute(pathname: string, search: string): boolean {
  if (pathname === '/official' || pathname === '/官网' || pathname.startsWith('/official/')) return true
  if (pathname !== '/') return false
  const params = new URLSearchParams(search)
  return !legacyWorkspaceParams.some(key => params.has(key))
}
